import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc'
import { EmbedScriptService } from '../embed-script.service'

declare var PrismeApp: any

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  imports: []
})
export class HomeComponent {

  // Legacy direct-open URLs (used by openStaging/openProduction/openValidation)
  private readonly VALIDATION_BOT_URL: string = "https://di-generateit.tech.orange/apps/secure-chat/agent_6f23bd3b5a9d48d9bad29fec726f9b26";
  private readonly STAGING_BOT_URL: string = "https://staging.generateit.tech.orange/apps/secure-chat/agent_5f9f619d6d7447639d2a92b80e1059f5";
  private readonly PRODUCTION_BOT_URL: string = "https://generateit.tech.orange/apps/secure-chat/agent_da6b1a50702044b29e5802c9241aec1e";
  

  // New PrismeApp embed parameters (validation and staging)
  private readonly VALIDATION_AGENT_ID: string = "agent_6f23bd3b5a9d48d9bad29fec726f9b26";
  private readonly VALIDATION_API_URL: string = "https://api.di-generateit.tech.orange/v2";
  private readonly STAGING_AGENT_ID: string = "agent_5f9f619d6d7447639d2a92b80e1059f5";
  private readonly STAGING_API_URL: string = "https://api.staging.generateit.tech.orange/v2";
  private readonly PRODUCTION_AGENT_ID: string = "agent_da6b1a50702044b29e5802c9241aec1e";
  private readonly PRODUCTION_API_URL: string = "https://api.generateit.tech.orange/v2";

  // Embed script URLs (one per environment)
  private readonly VALIDATION_EMBED_JS: string = "https://di-generateit.tech.orange/embed.js";
  private readonly STAGING_EMBED_JS: string = "https://staging.generateit.tech.orange/embed.js";
  private readonly PRODUCTION_EMBED_JS: string = "https://generateit.tech.orange/embed.js";

  
  protected prisme?: prisme = undefined
  
  constructor(private readonly oauthService: OAuthService, private readonly embedScriptService: EmbedScriptService) {
  }

  get sub(): string | undefined {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      return undefined;
    }
    return claims['sub'];
  }

  get idToken(): string {
    return this.oauthService.getIdToken();
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  refresh() {
    this.oauthService.refreshToken();
  }

  logout() {
    console.log('logout')
    this.oauthService.logOut();
  }

  login() {
    console.log('login')
    this.oauthService.loadDiscoveryDocumentAndLogin()
  }


  protected showChatBot(agentId: string, apiUrl: string, embedJs: string, title: string) {
    if (this.prisme) {
      this.hideChatBot()
    }

    this.embedScriptService.loadEmbedScript(embedJs).then(() => {
      // Snapshot des styles existants avant le mount
      console.log(document.head.querySelectorAll('style'))

      // ✅ Ajoutez votre style CSS ici
      const style = document.createElement('style');
      style.textContent = `
        .prisme-embed-popover {
          width: 800px !important;
          max-width: calc(100vw - 32px);
          border: 3px solid rgb(241, 110, 0) !important;
          border-radius: 1.4rem !important;
          box-shadow: 0 0 1rem rgb(241, 110, 0) !important;
        }       
      `;
      document.head.appendChild(style);

/*       // Force la barre d'actions (copier / pouce / régénérer) à rester visible en permanence
      const forceActionsVisible = () => {
        document.querySelectorAll<HTMLElement>('.prisme-embed-root .opacity-0').forEach(el => {
          el.style.setProperty('opacity', '1', 'important');
        });
      };
      forceActionsVisible();
      new MutationObserver(forceActionsVisible).observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Force le non affichage des sources
      const forceSourcesHidden = () => {
        document.querySelectorAll<HTMLElement>('[data-testid="chat-sources-list"]').forEach(el => {
          el.style.display = 'none';
        });
      };
      forceSourcesHidden();
      new MutationObserver(forceSourcesHidden).observe(document.body, {
        childList: true,
        subtree: true,
      }); */

      PrismeApp.mount({
        workspaceSlug: 'slug:agent-factory',
        agentId: agentId,
        apiUrl: apiUrl,
        mode: 'popover',
        auth: 'anonymous',
        orgSlug: 'orange-innov',
        theme: 'light',
        features: {
          enableFeedback: true,
          enableToolCalls: false,
          enableArtifacts: false
        },
        cssVariables: {
          "--primary":"27 100% 47%",
          "--primary-foreground":"0 0% 100%",
          "--card":"0 0% 100%",
          "--card-foreground":"240 10% 4%",
          "--accent": "204 6% 85%"
        },
        customCss: `
          .opacity-0 {
            opacity: 1 !important;
          }

          [data-testid="chat-sources-list"] {
            display: none !important;
          }
        `
      }).then((value: prisme) => {
        this.prisme = value;

        console.log(document.head.querySelectorAll('style'))

      });
    }).catch((error) => {
      console.error('Failed to load embed script:', error)
    });
  }

  protected showValidation() {
    this.showChatBot(this.VALIDATION_AGENT_ID, this.VALIDATION_API_URL, this.VALIDATION_EMBED_JS, "Chatbot on validation")
  }

  protected showStaging() {
    this.showChatBot(this.STAGING_AGENT_ID, this.STAGING_API_URL, this.STAGING_EMBED_JS, "Chatbot on staging")
  }

  protected showProduction() {
    this.showChatBot(this.PRODUCTION_AGENT_ID, this.PRODUCTION_API_URL, this.PRODUCTION_EMBED_JS, "Chatbot on production")
  }

  protected openValidation() {
    window.open(this.VALIDATION_BOT_URL, "_blank");
  }

  protected openStaging() {
    window.open(this.STAGING_BOT_URL, "_blank");
  }

  protected openProduction() {
    window.open(this.PRODUCTION_BOT_URL, "_blank");
  }

  protected hideChatBot() {
    if (this.prisme) {
      this.prisme.close();
      this.prisme.unmount();
      this.prisme = undefined;
    }

    // remove chatbot div if any
    const elt = document.getElementsByClassName('prisme-embed')
    if (elt.length > 0) {
      // remove parent div if any
      const parentDiv = elt.item(0)?.parentNode
      if (parentDiv) {
        parentDiv.parentNode?.removeChild(parentDiv)
      }
    }      
  }
}

export interface prisme {
  open: () => void
  close: () => void
  toggle: () => void
  isOpen: () => boolean
  unmount: () => void
  setTheme: (theme: string) => void
}
